<template>
  <div class="tm-breadcrumbs-skeleton">
    <tm-skeleton
      v-for="item in count"
      :key="item"
      type="QChip"
      width="80px"
      height="16px"
      class="mr-3"
    />
  </div>
</template>

<script setup lang="ts">
import TmSkeleton from '@/components/shared/skeletons/TmSkeleton.vue'

const { count = 2 } = defineProps<{
  count?: number
}>()
</script>

<style lang="scss" scoped>
.tm-breadcrumbs-skeleton {
  display: flex;
  align-items: center;
  padding: 12px 0;
}
</style>
